/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class TeamsAPI extends CacheEnabledApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'team';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  getAgents({ teamId }) {
    return axios.get(`${this.url}/${teamId}/team_members`);
  }

  addAgents({ teamId, agentsList }) {
    return axios.post(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
    });
  }

  updateAgents({ teamId, agentsList }) {
    return axios.patch(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
    });
  }

  getInboxAccess(teamId) {
    return axios.get(`${this.url}/${teamId}/inboxes`);
  }

  grantInboxAccess(teamId, inboxId) {
    return axios.post(`${this.url}/${teamId}/inboxes`, { inbox_id: inboxId });
  }

  revokeInboxAccess(teamId, inboxId) {
    return axios.delete(`${this.url}/${teamId}/inboxes/${inboxId}`);
  }
}

export default new TeamsAPI();
